module.exports = __webpack_public_path__ + "static/img/cxh.061a8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cxh.png
// module id = k12C
// module chunks = 0